import { render, staticRenderFns } from "./PlayerItem.vue?vue&type=template&id=64c972a0&scoped=true"
import script from "./PlayerItem.vue?vue&type=script&lang=js"
export * from "./PlayerItem.vue?vue&type=script&lang=js"
import style0 from "./PlayerItem.vue?vue&type=style&index=0&id=64c972a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c972a0",
  null
  
)

export default component.exports